import { getInscriptionStatus } from "@/services/inscription/getInscriptionStatus";
import type { InscriptionStatusResponse } from "@/services/inscription/types";
import { getRealityInfo } from "@/services/reality";
import type { RealityInfo } from "@/services/reality/types/reality.types";

export type DeadlineSnapshot = {
  realityInfo: RealityInfo;
  inscription: InscriptionStatusResponse;
};

/** Always hits the network — used for blocking modals (no React Query cache). */
export async function fetchDeadlineSnapshot(): Promise<DeadlineSnapshot> {
  const [realityInfo, inscription] = await Promise.all([
    getRealityInfo(),
    getInscriptionStatus(),
  ]);
  return { realityInfo, inscription };
}
